import { api } from "@/lib/api";

let sent = 0;

export const reportError = (error, extra = {}) => {
  if (sent >= 10) return;
  sent += 1;
  api
    .post("/logs/client-error", {
      message: String(error?.message || error || "Erreur inconnue").slice(0, 2000),
      stack: error?.stack ? String(error.stack).slice(0, 8000) : null,
      component_stack: extra.componentStack ? String(extra.componentStack).slice(0, 8000) : null,
      url: window.location.href.slice(0, 1000),
      user_agent: navigator.userAgent.slice(0, 500),
      source: extra.source || "boundary",
    })
    .catch(() => {});
};

export const installGlobalErrorHandlers = () => {
  window.addEventListener("error", (e) => reportError(e.error || e.message, { source: "window" }));
  window.addEventListener("unhandledrejection", (e) => {
    if (e.reason?.isAxiosError) return;
    reportError(e.reason, { source: "promise" });
  });
};
